import $ from 'jquery';
import { MetaRouter } from '../utils/metarouter';

import {
    addToCartEvent,
    scrapeGTMData,
    sendEcomEvent,
    viewProductEvent,
} from '../utils/gtm';
import { initZoomCarousel } from '../components/zoom-carousel';

import StorefrontService from '../services/storefront';
import * as Cookies from 'js-cookie';

export default ($product) => {
    initZoomCarousel();

    const data = scrapeGTMData($product);

    // URL
    const $CART_BUTTON = $('#product-add-to-cart');
    const sku = $CART_BUTTON.data('sku');

    // Quantity
    let quantity = 1;
    const MAX_QTY = $product.data('max');

    $('.product__quantity-icon--minus').on('click', () => {
        quantity = quantity > 1 ? quantity - 1 : quantity;
        $('.product__quantity--value').html(quantity);
    });

    $('.product__quantity-icon--plus').on('click', () => {
        quantity = quantity < MAX_QTY ? quantity + 1 : quantity;
        $('.product__quantity--value').html(quantity);
    });

    // Send event on Add to Cart
    $CART_BUTTON.on('click', async (e) => {
        e.preventDefault();

        $('#add-to-cart-loading').addClass('--active');
        $CART_BUTTON.prop('disabled', true);

        const storefront = await StorefrontService.getInstance();

        try {
            await storefront.addProductToCart(sku, quantity);

            //remove premium, replace space with underscore and lowercase it
            const name = data.name
                .toLowerCase()
                .replace('premium', '')
                .replace(/\s+/g, '_');

            addToCartEvent({
                name,
                id: sku,
                price: data.price,
                quantity,
                productType: 'shop',
            });

            MetaRouter.sendTrackEvent('added_to_cart', {
                screen_name: 'product_page',
                funnel_name: 'shop',
                price: data.price,
            });

            Cookies.set('lp__funnel', 'shop', {
                path: '/',
                domain: '.' + window.location.hostname,
            });

            let couponCode = window.sessionStorage.getItem('lp__promo');
            if (couponCode) {
                await storefront.applyCouponToCart(couponCode);
                window.sessionStorage.removeItem('lp__promo');
            }

            setTimeout(() => {
                window.location.href = LP__CONFIG.cartPageUrl;
            }, 250);
        } catch (err) {
            $('#add-to-cart-loading').removeClass('--active');
            $CART_BUTTON.prop('disabled', false);
            console.error(err);
        }
    });

    // Send event on product view
    let productName = data.name
        .toLowerCase()
        .replace('premium', '')
        .replace(/\s+/g, '_');

    viewProductEvent({
        name: productName,
        id: sku,
        price: data.price,
        quantity,
        productType: 'shop',
        currencyCode: data.currencyCode.toLowerCase(),
    });

    window.lp_analytics_variables = {
        little_passports_user_id: null,
    };
};
